import { Task } from './task';

export const MOCKTASKS: Task[] = [
  {
    title: 'Timeplan',
    icon: 'fa fa-handshake-o',
    image: 'http://www.nepbridgecompetition.co.uk/uploads/3/5/3/9/3539119/7564124_orig.jpg',
    description: '',
  }, {
    title: 'Team',
    icon: 'fa fa-laptop',
    image: 'http://www.nepbridgecompetition.co.uk/uploads/3/5/3/9/3539119/7564124_orig.jpg',
    description: '',
  }, {
    title: 'Incentives',
    icon: 'fa fa-anchor',
    image: 'http://www.nepbridgecompetition.co.uk/uploads/3/5/3/9/3539119/7564124_orig.jpg',
    description: '',
  }, {
    title: 'Structure',
    icon: 'fa fa-map',
    image: 'http://www.nepbridgecompetition.co.uk/uploads/3/5/3/9/3539119/7564124_orig.jpg',
    description: '',
  }, {
    title: 'Process',
    icon: 'fa fa-map',
    image: 'http://www.nepbridgecompetition.co.uk/uploads/3/5/3/9/3539119/7564124_orig.jpg',
    description: '',
  }
];



// WEBPACK FOOTER //
// /Users/Myrberg/Documents/spring_repo1/spring-app/src/app/base/components/keynote/components/next/components/implementation-strategy/tasks/mock-tasks.ts